module.exports = __webpack_public_path__ + "img/calendar.27cc4108.svg";